import gsap from "gsap";

const DURATION = 0.25;

function closePanel(panel) {
  gsap.to(panel, {
    height: 0,
    opacity: 0,
    duration: DURATION,
    ease: "power2.inOut",
    onComplete: () => gsap.set(panel, { display: "none" }),
  });
}

function openPanel(panel) {
  panel.style.display = "block";
  panel.style.overflow = "hidden";
  panel.style.opacity = "0";
  const fullHeight = panel.scrollHeight;
  panel.style.height = "0px";
  gsap.to(panel, { height: fullHeight, opacity: 1, duration: DURATION, ease: "power2.inOut" });
}

export default function Accordion() {
  Alpine.data("accordion", () => ({
    openIndex: 0,

    init() {
      const panels = this.$el.querySelectorAll("[data-accordion-panel]");
      const images = this.$el.querySelectorAll("[data-accordion-image]");

      panels.forEach((panel, i) => {
        if (i !== 0) gsap.set(panel, { display: "none", height: 0, opacity: 0, overflow: "hidden" });
        else gsap.set(panel, { overflow: "hidden" });
      });

      images.forEach((image, i) => {
        if (i !== 0) gsap.set(image, { autoAlpha: 0 });
      });
    },

    toggle(index) {
      const panels = this.$root.querySelectorAll("[data-accordion-panel]");
      const images = this.$root.querySelectorAll("[data-accordion-image]");
      const target = panels[index];

      if (!target) return;

      if (this.openIndex === index) return;

      if (this.openIndex !== null) {
        const prev = panels[this.openIndex];
        if (prev) closePanel(prev);
        gsap.to(images[this.openIndex], { autoAlpha: 0, duration: DURATION });
      }

      openPanel(target);
      gsap.to(images[index], { autoAlpha: 1, duration: DURATION, delay: 0.1 });

      this.openIndex = index;
    },

    isOpen(index) {
      return this.openIndex === index;
    },
  }));
}
